import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {SchedulePane} from '../mpe-dialog-helper';

@Component({
  selector: 'app-report-schedule-pane',
  templateUrl: './report-schedule-pane.component.html',
  styleUrls: ['./report-schedule-pane.component.scss']
})
export class ReportSchedulePaneComponent implements OnChanges {

  @Input() schedulePaneInfo!: SchedulePane;
  @Input() showErrorMessage = false;
  @Output() schedulePaneInfoChange = new EventEmitter<SchedulePane>();
  reportName = new UntypedFormControl('', [Validators.required]);

  constructor() { }

  ngOnChanges(): void {
    if (this.showErrorMessage) {
      this.reportName.markAsTouched();
    }
  }

  updateReportName(): void {
    this.schedulePaneInfo.reportName = this.reportName.value;
    this.schedulePaneInfoChange.emit(this.schedulePaneInfo);
  }

  updateIsGeneratedMonthly(): void {
    this.schedulePaneInfo.isMonthly = !this.schedulePaneInfo.isMonthly;
    this.schedulePaneInfoChange.emit(this.schedulePaneInfo);
  }
}
